import { useNavigate } from 'react-router-dom';
import { NNotification, NTable } from '@innersource-nn/novoui-react';
import useDatasetSchema from '../hooks/useDatasetSchema';
import Spinner from 'components/loader/Spinner';
import StatusInfoTab from 'components/tabs/StatusInfoTab';

const tableHeaders = [
    { header: 'Name', key: 'label' },
    { header: 'Type', key: 'typeName' },
];

const SchemaViewer = () => {
    const { tables, error, emptyTables, loading } = useDatasetSchema();
    const navigate = useNavigate();

    if (loading) {
        return <Spinner />;
    }

    return error !== '' ? (
        <StatusInfoTab
            child="schema"
            parent="dataset"
            error={true}
            message={error}
        />
    ) : (
        <div>
            <div className="text-true-blue">
                Only the first 10 columns are displayed here, to visualize all
                the columns. Please see below for more detailed content.
            </div>
            {emptyTables.length > 0 && (
                <NNotification
                    type="warning"
                    inline={true}
                    className="w-full mt-8"
                >
                    Due to incompatible formats we could not display:{' '}
                    {emptyTables.map((table) => table.GlueTableName).join(', ')}
                </NNotification>
            )}
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-16 mt-16">
                {tables.map((table) => {
                    return (
                        <div>
                            <div
                                className="text-true-blue font-semibold cursor-pointer hover:underline break-words"
                                onClick={() =>
                                    navigate(`/table/${table.tableUri}/`)
                                }
                            >
                                {table.GlueTableName}
                            </div>

                            <NTable
                                headers={tableHeaders}
                                headRowSize="md"
                                columnBorder={true}
                                key={table.tableUri}
                                items={table.columns.nodes}
                                stickyHeader={false}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default SchemaViewer;
